export const HANDLING_TYPE_TRIGGER_FIELDS = [
  'id_mine_origin',
  'id_destination_point',
  'id_material_truck',
];

export const mapById = (array = []) => Object.fromEntries(
  (array ?? []).map(item => [item.id, item]),
);

// Resolve o tipo de movimentação a partir do cadastro de flow_movements:
// ponto de origem/destino -> sub_element_type_id; material -> id_group.
// Retorna o id (string) do tipo encontrado ou null quando não há combinação ativa.
export const resolveHandlingTypeId = ({
  row,
  subElementsById,
  materialsById,
  flowMovements = [],
}) => {
  const originSub = subElementsById[row.id_mine_origin];
  const destSub = subElementsById[row.id_destination_point];
  const material = materialsById[row.id_material_truck];

  if (!originSub?.sub_element_type_id
    || !destSub?.sub_element_type_id
    || !material?.id_group) return null;

  const match = (flowMovements ?? []).find(fm => (
    Number(fm.active) === 1
    && String(fm.origin_sub_element_type_id) === String(originSub.sub_element_type_id)
    && String(fm.destination_sub_element_type_id) === String(destSub.sub_element_type_id)
    && String(fm.material_groups_id) === String(material.id_group)
  ));

  return match && Number(match.handling_type_id) ? String(match.handling_type_id) : null;
};
